Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionWheel = void 0;
exports.getSectionWheel = (params) => {
    const themeId = params.themeId || params.sectionWheels.defaultThemeId;
    const theme = params.sectionWheels.themes[themeId];
    if (!theme) {
        console.log(`Warning: theme '${themeId}' not found`);
        return;
    }
    const styles = theme.styles[params.wheelId];
    if (!styles) {
        console.log(`Warning: style for wheelId '${params.wheelId}' not found`);
        return;
    }
    const style = styles[params.variation];
    if (!style) {
        console.log(`Warning: style variation '${params.variation}' for wheelId '${params.wheelId}' not found`);
        return;
    }
    const allData = theme.data[params.wheelId];
    if (!allData) {
        console.log(`Warning: data for wheelId '${params.wheelId}' not found`);
        return;
    }
    const data = allData[params.variation];
    if (!data) {
        console.log(`Warning: data variation '${params.variation}' for wheelId '${params.wheelId}' not found`);
        return;
    }
    const wheel = {
        style,
        elementNcss: theme.elementNcss,
        wrSystemTheme: theme.wrSystemTheme,
        wrSystemConfig: params.sectionWheels.wrSystemConfig,
    };
    return {
        data,
        wheel,
    };
};
//# sourceMappingURL=get-wheel.js.map